// This file is automatically generated!
// Do not edit this file manually.

import React from 'react';
import PropTypes from 'prop-types';
import { default as AddIcon } from './icons/add';
import { default as AirFilterIcon } from './icons/air-filter';
import { default as AntiViralIcon } from './icons/anti-viral';
import { default as ArrowDropDownIcon } from './icons/arrow-drop-down';
import { default as BackArrowIcon } from './icons/back-arrow';
import { default as BackOrderIcon } from './icons/back-order';
import { default as BackflowPreventerIcon } from './icons/backflow-preventer';
import { default as BarChartIcon } from './icons/bar-chart';
import { default as BiohazardIcon } from './icons/biohazard';
import { default as BoilerIcon } from './icons/boiler';
import { default as BuiltUpRoofIcon } from './icons/built-up-roof';
import { default as BusinessIcon } from './icons/business';
import { default as CartIcon } from './icons/cart';
import { default as CatchBasinsIcon } from './icons/catch-basins';
import { default as CheckMarkSquareIcon } from './icons/check-mark-square';
import { default as CheckboxIcon } from './icons/checkbox';
import { default as ChillerIcon } from './icons/chiller';
import { default as ClearIcon } from './icons/clear';
import { default as ClipboardIcon } from './icons/clipboard';
import { default as ClockIcon } from './icons/clock';
import { default as CompleteIcon } from './icons/complete';
import { default as ConcreteStainingIcon } from './icons/concrete-staining';
import { default as ConcreteIcon } from './icons/concrete';
import { default as CoolingTowerIcon } from './icons/cooling-tower';
import { default as DeleteIcon } from './icons/delete';
import { default as DesktopIcon } from './icons/desktop';
import { default as DishMachineIcon } from './icons/dish-machine';
import { default as DoNotDisturbIcon } from './icons/do-not-disturb';
import { default as DollarIcon } from './icons/dollar';
import { default as DownArrowIcon } from './icons/down-arrow';
import { default as DownloadIcon } from './icons/download';
import { default as DragHandleIcon } from './icons/drag-handle';
import { default as DrainCleanerIcon } from './icons/drain-cleaner';
import { default as EditIcon } from './icons/edit';
import { default as EllipsisVerticalIcon } from './icons/ellipsis-vertical';
import { default as EpoxyFlooringIcon } from './icons/epoxy-flooring';
import { default as ExcavationIcon } from './icons/excavation';
import { default as ExitIcon } from './icons/exit';
import { default as ExteriorStainingIcon } from './icons/exterior-staining';
import { default as FailureIcon } from './icons/failure';
import { default as FanIcon } from './icons/fan';
import { default as FaucetIcon } from './icons/faucet';
import { default as FileDocumentIcon } from './icons/file-document';
import { default as FileExcelIcon } from './icons/file-excel';
import { default as FilePdfIcon } from './icons/file-pdf';
import { default as FileWordIcon } from './icons/file-word';
import { default as FileIcon } from './icons/file';
import { default as FireAlarmIcon } from './icons/fire-alarm';
import { default as FlooringIcon } from './icons/flooring';
import { default as ForwardArrowIcon } from './icons/forward-arrow';
import { default as FramingIcon } from './icons/framing';
import { default as FurnaceIcon } from './icons/furnace';
import { default as GarageDoorIcon } from './icons/garage-door';
import { default as GasPipeIcon } from './icons/gas-pipe';
import { default as GeneralMaintenanceIcon } from './icons/general-maintenance';
import { default as GeneratorEngineIcon } from './icons/generator-engine';
import { default as GeneratorIcon } from './icons/generator';
import { default as GlobeIcon } from './icons/globe';
import { default as GreaseTrapIcon } from './icons/grease-trap';
import { default as HamburgerMenuIcon } from './icons/hamburger-menu';
import { default as HelpIcon } from './icons/help';
import { default as HomeIcon } from './icons/home';
import { default as HydrojettingIcon } from './icons/hydrojetting';
import { default as ImageIcon } from './icons/image';
import { default as InfoIcon } from './icons/info';
import { default as InfraredScanningIcon } from './icons/infrared-scanning';
import { default as IonIcon } from './icons/ion';
import { default as KeypadIcon } from './icons/keypad';
import { default as KitchenHoodIcon } from './icons/kitchen-hood';
import { default as LaundryIcon } from './icons/laundry';
import { default as LawnMowerIcon } from './icons/lawn-mower';
import { default as LightbulbBoltIcon } from './icons/lightbulb-bolt';
import { default as LightbulbCrossedOutSolidIcon } from './icons/lightbulb-crossed-out-solid';
import { default as LightbulbCrossedOutIcon } from './icons/lightbulb-crossed-out';
import { default as LightbulbGlowingBoltIcon } from './icons/lightbulb-glowing-bolt';
import { default as LightbulbGlowingIcon } from './icons/lightbulb-glowing';
import { default as LightbulbSolidBoltGroupIcon } from './icons/lightbulb-solid-bolt-group';
import { default as LightbulbSolidBoltIcon } from './icons/lightbulb-solid-bolt';
import { default as LightbulbSolidGlowingBoltIcon } from './icons/lightbulb-solid-glowing-bolt';
import { default as LightbulbSolidGlowingIcon } from './icons/lightbulb-solid-glowing';
import { default as LightbulbSolidGroupIcon } from './icons/lightbulb-solid-group';
import { default as LightbulbSolidIcon } from './icons/lightbulb-solid';
import { default as LightbulbIcon } from './icons/lightbulb';
import { default as LoadingIcon } from './icons/loading';
import { default as LocalShippingIcon } from './icons/local-shipping';
import { default as LocationIcon } from './icons/location';
import { default as LockOpenIcon } from './icons/lock-open';
import { default as LockIcon } from './icons/lock';
import { default as LowVoltageConnectionIcon } from './icons/low-voltage-connection';
import { default as MagnifyMinusIcon } from './icons/magnify-minus';
import { default as MagnifyPlusIcon } from './icons/magnify-plus';
import { default as MagnifyIcon } from './icons/magnify';
import { default as MakeupAirUnitIcon } from './icons/makeup-air-unit';
import { default as MasonryIcon } from './icons/masonry';
import { default as MetalRoofIcon } from './icons/metal-roof';
import { default as MeterIcon } from './icons/meter';
import { default as MopIcon } from './icons/mop';
import { default as MuddingIcon } from './icons/mudding';
import { default as MudjackingIcon } from './icons/mudjacking';
import { default as MultimeterIcon } from './icons/multimeter';
import { default as NavigationNextIcon } from './icons/navigation-next';
import { default as NavigationPrevIcon } from './icons/navigation-prev';
import { default as NurseCallIcon } from './icons/nurse-call';
import { default as OutOfStockIcon } from './icons/out-of-stock';
import { default as OutletIcon } from './icons/outlet';
import { default as OvenIcon } from './icons/oven';
import { default as PageFirstIcon } from './icons/page-first';
import { default as PageLastIcon } from './icons/page-last';
import { default as PaintingIcon } from './icons/painting';
import { default as ParkingLotLightingIcon } from './icons/parking-lot-lighting';
import { default as ParkingLotStripingIcon } from './icons/parking-lot-striping';
import { default as ParkingLotIcon } from './icons/parking-lot';
import { default as PendingIcon } from './icons/pending';
import { default as PersonIcon } from './icons/person';
import { default as PestControlIcon } from './icons/pest-control';
import { default as PhoneIcon } from './icons/phone';
import { default as PipeInsulationIcon } from './icons/pipe-insulation';
import { default as PlayIcon } from './icons/play';
import { default as PortableGeneratorIcon } from './icons/portable-generator';
import { default as PreviewIcon } from './icons/preview';
import { default as PrintIcon } from './icons/print';
import { default as QrCodeIcon } from './icons/qr-code';
import { default as RefreshIcon } from './icons/refresh';
import { default as RefrigeratorIcon } from './icons/refrigerator';
import { default as RoofIcon } from './icons/roof';
import { default as RulerIcon } from './icons/ruler';
import { default as SearchIcon } from './icons/search';
import { default as SecurityCameraIcon } from './icons/security-camera';
import { default as SecurityIcon } from './icons/security';
import { default as SettingsIcon } from './icons/settings';
import { default as ShieldIcon } from './icons/shield';
import { default as ShingleRoofIcon } from './icons/shingle-roof';
import { default as ShowMoreIcon } from './icons/show-more';
import { default as SignageIcon } from './icons/signage';
import { default as SinglePlyRoofIcon } from './icons/single-ply-roof';
import { default as SitemapIcon } from './icons/sitemap';
import { default as SmartSortIcon } from './icons/smart-sort';
import { default as SnowPlowIcon } from './icons/snow-plow';
import { default as SortIcon } from './icons/sort';
import { default as SpinnerIcon } from './icons/spinner';
import { default as SprinklerIcon } from './icons/sprinkler';
import { default as SuccessIcon } from './icons/success';
import { default as SyncIcon } from './icons/sync';
import { default as TemporaryCoolingIcon } from './icons/temporary-cooling';
import { default as ThermometerIcon } from './icons/thermometer';
import { default as ThumbsDownIcon } from './icons/thumbs-down';
import { default as ThumbsUpIcon } from './icons/thumbs-up';
import { default as TinSnipsIcon } from './icons/tin-snips';
import { default as UndoIcon } from './icons/undo';
import { default as UpArrowIcon } from './icons/up-arrow';
import { default as UploadIcon } from './icons/upload';
import { default as UvLightingIcon } from './icons/uv-lighting';
import { default as ViewListIcon } from './icons/view-list';
import { default as WalkInFreezerIcon } from './icons/walk-in-freezer';
import { default as WarningAmberIcon } from './icons/warning-amber';
import { default as WarningIcon } from './icons/warning';
import { default as WaterFiltrationIcon } from './icons/water-filtration';
import { default as WaterHeaterIcon } from './icons/water-heater';
import { default as WaterSourceHeatPumpIcon } from './icons/water-source-heat-pump';
import { default as WindowIcon } from './icons/window';
import { default as WrenchIcon } from './icons/wrench';

const allIcons = {
	'add': AddIcon,
	'air-filter': AirFilterIcon,
	'anti-viral': AntiViralIcon,
	'arrow-drop-down': ArrowDropDownIcon,
	'back-arrow': BackArrowIcon,
	'back-order': BackOrderIcon,
	'backflow-preventer': BackflowPreventerIcon,
	'bar-chart': BarChartIcon,
	'biohazard': BiohazardIcon,
	'boiler': BoilerIcon,
	'built-up-roof': BuiltUpRoofIcon,
	'business': BusinessIcon,
	'cart': CartIcon,
	'catch-basins': CatchBasinsIcon,
	'check-mark-square': CheckMarkSquareIcon,
	'checkbox': CheckboxIcon,
	'chiller': ChillerIcon,
	'clear': ClearIcon,
	'clipboard': ClipboardIcon,
	'clock': ClockIcon,
	'complete': CompleteIcon,
	'concrete-staining': ConcreteStainingIcon,
	'concrete': ConcreteIcon,
	'cooling-tower': CoolingTowerIcon,
	'delete': DeleteIcon,
	'desktop': DesktopIcon,
	'dish-machine': DishMachineIcon,
	'do-not-disturb': DoNotDisturbIcon,
	'dollar': DollarIcon,
	'down-arrow': DownArrowIcon,
	'download': DownloadIcon,
	'drag-handle': DragHandleIcon,
	'drain-cleaner': DrainCleanerIcon,
	'edit': EditIcon,
	'ellipsis-vertical': EllipsisVerticalIcon,
	'epoxy-flooring': EpoxyFlooringIcon,
	'excavation': ExcavationIcon,
	'exit': ExitIcon,
	'exterior-staining': ExteriorStainingIcon,
	'failure': FailureIcon,
	'fan': FanIcon,
	'faucet': FaucetIcon,
	'file-document': FileDocumentIcon,
	'file-excel': FileExcelIcon,
	'file-pdf': FilePdfIcon,
	'file-word': FileWordIcon,
	'file': FileIcon,
	'fire-alarm': FireAlarmIcon,
	'flooring': FlooringIcon,
	'forward-arrow': ForwardArrowIcon,
	'framing': FramingIcon,
	'furnace': FurnaceIcon,
	'garage-door': GarageDoorIcon,
	'gas-pipe': GasPipeIcon,
	'general-maintenance': GeneralMaintenanceIcon,
	'generator-engine': GeneratorEngineIcon,
	'generator': GeneratorIcon,
	'globe': GlobeIcon,
	'grease-trap': GreaseTrapIcon,
	'hamburger-menu': HamburgerMenuIcon,
	'help': HelpIcon,
	'home': HomeIcon,
	'hydrojetting': HydrojettingIcon,
	'image': ImageIcon,
	'info': InfoIcon,
	'infrared-scanning': InfraredScanningIcon,
	'ion': IonIcon,
	'keypad': KeypadIcon,
	'kitchen-hood': KitchenHoodIcon,
	'laundry': LaundryIcon,
	'lawn-mower': LawnMowerIcon,
	'lightbulb-bolt': LightbulbBoltIcon,
	'lightbulb-crossed-out-solid': LightbulbCrossedOutSolidIcon,
	'lightbulb-crossed-out': LightbulbCrossedOutIcon,
	'lightbulb-glowing-bolt': LightbulbGlowingBoltIcon,
	'lightbulb-glowing': LightbulbGlowingIcon,
	'lightbulb-solid-bolt-group': LightbulbSolidBoltGroupIcon,
	'lightbulb-solid-bolt': LightbulbSolidBoltIcon,
	'lightbulb-solid-glowing-bolt': LightbulbSolidGlowingBoltIcon,
	'lightbulb-solid-glowing': LightbulbSolidGlowingIcon,
	'lightbulb-solid-group': LightbulbSolidGroupIcon,
	'lightbulb-solid': LightbulbSolidIcon,
	'lightbulb': LightbulbIcon,
	'loading': LoadingIcon,
	'local-shipping': LocalShippingIcon,
	'location': LocationIcon,
	'lock-open': LockOpenIcon,
	'lock': LockIcon,
	'low-voltage-connection': LowVoltageConnectionIcon,
	'magnify-minus': MagnifyMinusIcon,
	'magnify-plus': MagnifyPlusIcon,
	'magnify': MagnifyIcon,
	'makeup-air-unit': MakeupAirUnitIcon,
	'masonry': MasonryIcon,
	'metal-roof': MetalRoofIcon,
	'meter': MeterIcon,
	'mop': MopIcon,
	'mudding': MuddingIcon,
	'mudjacking': MudjackingIcon,
	'multimeter': MultimeterIcon,
	'navigation-next': NavigationNextIcon,
	'navigation-prev': NavigationPrevIcon,
	'nurse-call': NurseCallIcon,
	'out-of-stock': OutOfStockIcon,
	'outlet': OutletIcon,
	'oven': OvenIcon,
	'page-first': PageFirstIcon,
	'page-last': PageLastIcon,
	'painting': PaintingIcon,
	'parking-lot-lighting': ParkingLotLightingIcon,
	'parking-lot-striping': ParkingLotStripingIcon,
	'parking-lot': ParkingLotIcon,
	'pending': PendingIcon,
	'person': PersonIcon,
	'pest-control': PestControlIcon,
	'phone': PhoneIcon,
	'pipe-insulation': PipeInsulationIcon,
	'play': PlayIcon,
	'portable-generator': PortableGeneratorIcon,
	'preview': PreviewIcon,
	'print': PrintIcon,
	'qr-code': QrCodeIcon,
	'refresh': RefreshIcon,
	'refrigerator': RefrigeratorIcon,
	'roof': RoofIcon,
	'ruler': RulerIcon,
	'search': SearchIcon,
	'security-camera': SecurityCameraIcon,
	'security': SecurityIcon,
	'settings': SettingsIcon,
	'shield': ShieldIcon,
	'shingle-roof': ShingleRoofIcon,
	'show-more': ShowMoreIcon,
	'signage': SignageIcon,
	'single-ply-roof': SinglePlyRoofIcon,
	'sitemap': SitemapIcon,
	'smart-sort': SmartSortIcon,
	'snow-plow': SnowPlowIcon,
	'sort': SortIcon,
	'spinner': SpinnerIcon,
	'sprinkler': SprinklerIcon,
	'success': SuccessIcon,
	'sync': SyncIcon,
	'temporary-cooling': TemporaryCoolingIcon,
	'thermometer': ThermometerIcon,
	'thumbs-down': ThumbsDownIcon,
	'thumbs-up': ThumbsUpIcon,
	'tin-snips': TinSnipsIcon,
	'undo': UndoIcon,
	'up-arrow': UpArrowIcon,
	'upload': UploadIcon,
	'uv-lighting': UvLightingIcon,
	'view-list': ViewListIcon,
	'walk-in-freezer': WalkInFreezerIcon,
	'warning-amber': WarningAmberIcon,
	'warning': WarningIcon,
	'water-filtration': WaterFiltrationIcon,
	'water-heater': WaterHeaterIcon,
	'water-source-heat-pump': WaterSourceHeatPumpIcon,
	'window': WindowIcon,
	'wrench': WrenchIcon,
};

export const iconTypes = Object.keys(allIcons);

export default function IconLegacy(props) {
	const Icon = allIcons[props.type];
	return <Icon {...props} />;
}

IconLegacy.propTypes = {
	className: PropTypes.string,
	color: PropTypes.string,
	size: PropTypes.string,
	style: PropTypes.object,
	type: PropTypes.oneOf(iconTypes).isRequired
};
